import registerDecoration from 'utils/registerDecoration';

import inview from 'decorators/inview';
import animateIn from 'decorators/animateIn';
import onevent from 'decorators/onevent';
import iframe from 'decorators/iframe';
import scrollto from 'decorators/scrollto';
import logoAnimCookie from 'decorators/logoAnimCookie';
import homepageTop from 'decorators/homepage-top';
// import stagger from 'decorators/stagger';
// import newsletter from 'decorators/newsletter';
// import scrollScale from 'decorators/scroll-scale';
// import locationStagger from 'decorators/location-stagger';

export default () => {
  registerDecoration('.animate', animateIn);

  registerDecoration('[appear]', inview, {
    name: 'inview',
    timeout: 800,
    threshold: 0.05,
    props: ['transform'],
  });

  registerDecoration('[appear-children] > *', inview, {
    name: 'inview',
    timeout: 800,
    props: ['transform'],
  });

  registerDecoration('[event]', onevent, {
    name: 'event',
    eventName: undefined,
  });

  registerDecoration('[homepage-top]', homepageTop, {
    threshold: [0, 0.25, 0.5, 0.75, 1],
  });
  // registerDecoration('[block-stagger]', stagger, {
  //   threshold: [0.75, 1],
  //   elements: [
  //     '.image:not(.decor)',
  //     '.header',
  //     'h2',
  //     'p',
  //     '.button',
  //     '.footer',
  //   ],
  // });
  // registerDecoration('[slider-stagger]', stagger, {
  //   threshold: [0.3, 1],
  //   elements: ['.filter', '.slider'],
  // });
  // registerDecoration('[newsletter]', newsletter, {
  //   threshold: [0.5, 1],
  // });
  registerDecoration('.body figure iframe', iframe);
  registerDecoration('a[scrollto-target]', scrollto);
  registerDecoration('#logo-anim-container', logoAnimCookie);
  // registerDecoration('.block-location', locationStagger);
  // registerDecoration('[scroll-scale]', scrollScale);
};
